import React, { useState } from 'react'
import useDebounce from '../../utils/services/useDebounce'
import { useEffect } from 'react'

// Fonction pour effectuer la requête vers Nominatim
const fetchAddressSuggestions = async (query) => {
    try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${query}&addressdetails=1&limit=5`
        )
        const data = await response.json()
        return data // Renvoie les suggestions d'adresses
    } catch (error) {
        console.error('Error fetching address suggestions:', error)
        return []
    }
}

const AddressAutocomplete = ({ setAddress }) => {
    const [query, setQuery] = useState('')
    const [suggestions, setSuggestions] = useState([])

    // Utiliser le hook debounce avec un délai en ms
    const debouncedQuery = useDebounce(query, 1000)

    // Utiliser l'effet pour faire une requête API seulement lorsque la requête est "debounced"
    useEffect(() => {
        if (debouncedQuery.length > 2) {
            // Lancer la requête seulement si plus de 2 caractères
            const fetchSuggestions = async () => {
                const results = await fetchAddressSuggestions(debouncedQuery)
                setSuggestions(results)
            }

            fetchSuggestions()
        } else {
            setSuggestions([]) // Réinitialiser si moins de 3 caractères
        }
    }, [debouncedQuery])

    const handleInputChange = (e) => {
        setQuery(e.target.value) // Mettre à jour la valeur saisie
        setAddress(null)
    }

    const handleSuggestionSelect = (address) => {
        setQuery(address.display_name) // Affiche l'adresse sélectionnée dans l'input
        setSuggestions([]) // Masque les suggestions
        setAddress(address)
    }

    return (
        <div>
            <input
                type="text"
                value={query}
                onChange={handleInputChange}
                placeholder="Adresse"
            />
            <ul style={{ listStyleType: 'none', padding: 0 }}>
                {suggestions.map((suggestion, index) => (
                    <li
                        key={index}
                        onClick={() => handleSuggestionSelect(suggestion)}
                        style={{ cursor: 'pointer', padding: '8px 0' }}
                    >
                        {suggestion.display_name}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default AddressAutocomplete
